/* Component in the Callsheet component to display the Callsheet 
   Hospital info in mobile
 * Contains the Map component to display Google maps */
import React from 'react';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import styles from "../../../styles/Callsheets.module.css";
// import Map from '../../../components/Map';
// import goo_map from "../../../assets/goo-map.png";
// import { Image } from 'react-bootstrap';
// import { useState } from 'react';

const HospitalPage2 = ({callsheet, setShow}) => {
    // const [showHosMap, setShowHosMap] = useState(false);
    const {nearest_hospital, hospital_address_line_1,
        hospital_address_line_2, hospital_address_line_3} = callsheet;
    // const hospital_address = `${nearest_hospital}, ${hospital_address_line_1}, ${hospital_address_line_2}`;

  return (
    <div className='mt-3'>
        <div className={`mb-3 ${styles.SubTitleSpan }`}>
        <span className={`float-right ${styles.Close }`} onClick={() => setShow(false) } >Close</span> 
        <h4 className={`pl-5 text-center`} 
        style={{ textTransform: 'uppercase'}} >Nearest Hospital </h4>
        </div>
        <div >
            <Row className='mb-1'>
              <Col xs={12} className='ml-5 pl-5'>
              <h5 className={`mb-1 pl-0 ${styles.WhiteAqua}`}>{nearest_hospital} </h5>
              <p className={`mb-1 pl-0 ${styles.WhiteAqua}`}>{hospital_address_line_1} </p>
              <p className={`mb-1 pl-0 ${styles.WhiteAqua}`}>{hospital_address_line_2} </p>
              <p className={`mb-1 pl-0 ${styles.WhiteAqua}`}>{hospital_address_line_3} </p>
              </Col>
            </Row>
            </div>
    </div>
  )
}

export default HospitalPage2